
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.422 9H2.58c-.32 0-.58.272-.58.609 0 .127.038.246.101.343a.62.62 0 00.122.19l2.554 2.68a.563.563 0 00.82 0 .632.632 0 000-.861l-1.663-1.744h9.486c.32 0 .58-.272.58-.608 0-.337-.258-.609-.578-.609zM2.579 6h10.842c.32 0 .579-.272.579-.608a.627.627 0 00-.101-.344.631.631 0 00-.084-.145l-2.09-2.68a.56.56 0 00-.815-.085.63.63 0 00-.08.856l1.394 1.79H2.579c-.32 0-.579.271-.579.608 0 .336.26.608.58.608z","fill-opacity":".65","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    